const ChallengesUtilizationCard = ({
  tileLabel = '',
  title1 = '',
  title2 = '',
  liner1 = '',
  liner2 = '',
  classes = '',
}) => {
  return (
    <div
      className={`flex min-h-[152px] flex-col rounded-lg border border-gray-200 bg-white p-5 text-center shadow-sm transition-shadow duration-200 hover:shadow-md ${classes}`}
    >
      {tileLabel ? <p className='mb-0 text-left text-xs font-medium leading-normal text-gray-600'>{tileLabel}</p> : null}
      <div className={`flex flex-row items-stretch justify-center ${tileLabel ? 'mt-3' : ''}`}>
        <div className='min-w-0 flex-1 px-2'>
          <div className='text-3xl font-bold tabular-nums leading-none tracking-tight text-gray-900 font-jetbrains-mono'>{title1}</div>
          <p className='mb-0 mt-2 text-sm font-normal text-gray-600'>{liner1}</p>
        </div>
        <div className='w-px shrink-0 self-stretch bg-gray-200' aria-hidden />
        <div className='min-w-0 flex-1 px-2'>
          <div className='font-jetbrains-mono text-3xl font-bold tabular-nums leading-none tracking-tight text-gray-900'>{title2}</div>
          <p className='mb-0 mt-2 text-sm font-normal text-gray-600'>{liner2}</p>
        </div>
      </div>
    </div>
  );
};

export default ChallengesUtilizationCard